import { Component, ChangeDetectorRef } from '@angular/core'
import { AgFilterComponent } from 'ag-grid-angular'
import { LookupFilterComponent } from './lookup-filter/lookup-filter.component'
import { Option } from '../../app-select/option'

@Component({
  selector: 'app-boolean-filter',
  templateUrl: './lookup-filter/lookup-filter.component.html',
  styleUrls: ['./lookup-filter/lookup-filter.component.scss'],
  standalone: false
})
export class BooleanFilterComponent extends LookupFilterComponent implements AgFilterComponent {
  constructor(cdr: ChangeDetectorRef) {
    super(cdr)
    this.items = [new Option(true, 'Yes', true), new Option(false, 'No', false)]
  }
}
